import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "../lib/api";
import { SectionTitle } from "../components/Bits";
import { Phone, ArrowRight, Bell, Users, Landmark, Scale } from "lucide-react";

export default function Home() {
  const [settings, setSettings] = useState({});
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data || {}));
    api.get("/notices").then((r) => setNotices(r.data.slice(0, 4)));
  }, []);

  const home = settings.home || {};

  return (
    <div data-testid="home-page">
      {/* HERO */}
      <section className="hero-grain text-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 py-16 sm:py-24 grid lg:grid-cols-2 gap-12 items-center">
          <div className="fade-up">
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
              High Court Advocates' Bar Association
            </h1>
            <p className="mt-3 font-garamond text-2xl text-[#e6d9bd]">Jabalpur · Madhya Pradesh</p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/about" className="btn-gold rounded-full px-6 py-3 text-sm font-semibold flex items-center gap-2" data-testid="hero-about-btn">
                About the Association <ArrowRight size={16} />
              </Link>
            </div>
          </div>
          <div className="flex justify-center fade-up">
            <div className="relative">
              <div className="absolute inset-0 rounded-full bg-[#D4AF37]/20 blur-3xl" />
              <img src="/logo.jpg" alt="HC ABA emblem" className="relative w-64 h-64 sm:w-80 sm:h-80 rounded-full object-cover drop-shadow-2xl ring-4 ring-[#D4AF37]/40" data-testid="hero-emblem" />
            </div>
          </div>
        </div>
        <div className="gold-line h-1 w-full" />
      </section>

      {/* STATS */}
      <section className="bg-white border-b border-[#E5DECF]">
        <div className="max-w-2xl mx-auto px-4 py-10 grid grid-cols-2 gap-6">
          {[
            { icon: Landmark, label: "Years of Legacy", value: "20" },
            { icon: Users, label: "Members", value: home.total_advocates || "500+" },
          ].map((s, i) => (
            <div key={i} className="text-center" data-testid={`stat-${i}`}>
              <s.icon className="mx-auto text-[#8A6320] mb-2" size={28} />
              <div className="font-display text-3xl font-bold text-[#0B2E63]">{s.value}</div>
              <div className="text-xs uppercase tracking-widest text-[#5A6270] mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* PRESIDENT MESSAGE */}
      <section className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-3 gap-10 items-start">
          <div className="lg:col-span-2">
            <SectionTitle eyebrow="From the Association" title="A Legacy of Service to the Bar" />
            <p className="font-garamond text-xl leading-relaxed text-[#3a2f2a] italic border-l-4 border-[#D4AF37] pl-5">
              “{home.president_message || "The Association stands as a pillar of the legal fraternity of Madhya Pradesh."}”
            </p>
          </div>
          <div className="card-elite rounded-lg p-6" data-testid="home-notices">
            <h3 className="font-display text-xl text-[#0B2E63] font-semibold mb-4 flex items-center gap-2"><Bell size={18} /> Latest Notices</h3>
            <ul className="space-y-4">
              {notices.map((n) => (
                <li key={n.id} className="border-b border-[#F0E9DA] pb-3 last:border-0">
                  <Link to="/notices" className="group">
                    <div className="text-xs text-[#8A6320] font-semibold">{n.date}</div>
                    <div className="text-sm text-[#2a2422] group-hover:text-[#123B7A] font-medium leading-snug">{n.title}</div>
                  </Link>
                </li>
              ))}
              {notices.length === 0 && <li className="text-sm text-[#5A6270]">No notices yet.</li>}
            </ul>
            <Link to="/notices" className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#123B7A]">View all <ArrowRight size={14} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
